<template>
  <div>
    <v-container fluid>
      <base-material-card
        icon="mdi-clipboard-text"
        title="รายละเอียดผู้ยื่นย้าย สายบริหาร – ความเห็นคณะกรรมการสถานศึกษา"
      >
        <!-- ── ปุ่มพิมพ์ทุกรายการ ── -->
        <v-row class="mb-2" v-if="transference_manage_locations.length > 0">
          <v-col cols="12" class="d-flex align-center" style="gap:8px;">
            <v-btn
              color="error darken-2"
              dark
              rounded
              :loading="printingAll"
              @click="printAllCommitteePdf"
            >
              <v-icon left>mdi-printer-pos</v-icon>
              พิมพ์แบบเสนอความเห็นทั้งหมด ({{
                transference_manage_locations.length
              }}
              รายการ)
            </v-btn>
            <v-chip color="info" dark small>
              <v-icon x-small left>mdi-information</v-icon>
              พิมพ์แล้วนำมาลงนาม และสแกนแนบกลับระบบ
            </v-chip>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="8">
            <v-alert type="info" dense outlined class="mb-2">
              <strong>ขั้นตอนการดำเนินการ</strong><br />
              1. ประชุมพิจารณาจากแบบเสนอย้ายของผู้เสนอแต่ละราย (ปุ่ม PDF
              สีน้ำเงิน)<br />
              2. กด Icon สีเหลือง เพื่อเปิดแบบบันทึกความเห็นคณะกรรมการฯ<br />
              3. กรอกข้อมูลให้ครบถ้วนตามแบบ "แบบเสนอความเห็นคณะกรรมการสถานศึกษา"
              แล้วบันทึก<br />
              4. ตรวจสอบความถูกต้องจาก Chip สีเขียว/เหลือง —
              สามารถแก้ไขได้ตลอดในช่วงที่ระบบเปิด
            </v-alert>
          </v-col>
          <v-col cols="12" md="4">
            <v-alert type="error" dense outlined>
              <strong>* สายบริหารจะปรากฏเมื่อผู้เสนอย้ายเข้า</strong><br />
              ปิดระบบวันที่ :
              <strong>{{
                periods.period_college_stop | moment("D MMMM YYYY")
              }}</strong>
            </v-alert>
            <!-- สรุปสถานะรายการ -->
            <v-card outlined class="pa-2 mt-1">
              <div class="caption grey--text">สรุปสถานะ</div>
              <v-row dense>
                <v-col cols="4" class="text-center">
                  <div class="title success--text">{{ countApprop }}</div>
                  <div class="caption">เห็นชอบ</div>
                </v-col>
                <v-col cols="4" class="text-center">
                  <div class="title warning--text">{{ countInapprop }}</div>
                  <div class="caption">ไม่เห็นชอบ</div>
                </v-col>
                <v-col cols="4" class="text-center">
                  <div class="title grey--text">{{ countPending }}</div>
                  <div class="caption">รอดำเนินการ</div>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>

        <!-- ── ค้นหา + ตัวกรองสถานะ ── -->
        <v-row dense class="mb-2">
          <v-col cols="12" md="6">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="ค้นหา ระบุชื่อ รหัส หรือข้อความที่เกี่ยวข้อง"
              single-line
              hide-details
              dense
              filled
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-btn-toggle v-model="filterStatus" mandatory dense>
              <v-btn value="all" small>ทั้งหมด</v-btn>
              <v-btn value="approp" small color="success" dark>เห็นชอบ</v-btn>
              <v-btn value="inapprop" small color="warning" dark
                >ไม่เห็นชอบ</v-btn
              >
              <v-btn value="pending" small color="grey" dark>รอดำเนินการ</v-btn>
              <v-btn value="incomplete" small color="error" dark
                >ข้อมูลไม่สมบูรณ์</v-btn
              >
            </v-btn-toggle>
          </v-col>
        </v-row>

        <v-data-table
          :loading="loading"
          loading-text="กำลังโหลดข้อมูล กรุณารอสักครู่..."
          :headers="headers"
          :items="filteredItems"
          :search="search"
          :items-per-page="25"
          :footer-props="{ 'items-per-page-options': [25, 50, 100, -1] }"
        >
          <template v-slot:no-data>
            <div class="text-center pa-6 grey--text">
              <v-icon size="40" color="grey">mdi-database-off-outline</v-icon>
              <div class="mt-2">
                ไม่พบข้อมูลผู้ยื่นย้ายในรอบนี้
              </div>
            </div>
          </template>
          <template v-slot:item="{ item, index }">
            <tr :class="rowClass(item)">
              <td class="text-center">{{ index + 1 }}</td>
              <td class="text-center font-weight-bold">
                {{ item.manage_id_ref }}
              </td>
              <td class="text-center">
                {{ item.title_s }}{{ item.frist_name }} {{ item.last_name }}
              </td>
              <td class="text-center">{{ item.college_name_now }}</td>
              <td class="text-center">
                {{ item.time_ss + "/" + item.year_ss }}
              </td>
              <td class="text-center">{{ item.manage_age_app_time }}</td>
              <!-- ลำดับที่ขอย้ายมา -->
              <td class="text-center">{{ item.manage_location_sequence_n }}</td>
              <!-- ปุ่มดูแบบเสนอย้าย -->
              <td class="text-center">
                <v-btn
                  text
                  color="info"
                  @click.stop="openPdfmanage_id_refDialog(item)"
                >
                  <v-icon large>mdi-file-pdf-box</v-icon>
                </v-btn>
              </td>
              <!-- สถานะความเห็น + ปุ่มกรอก/แก้ไข -->
              <td class="text-center">
                <template
                  v-if="
                    item.Mcommittee === 'approp' ||
                      item.Mcommittee === 'inapprop'
                  "
                >
                  <div class="d-flex flex-column align-center" style="gap:4px;">
                    <!-- Chip แสดงผล — กดเพื่อดูไฟล์ -->
                    <v-chip
                      :color="item.Mcommittee === 'approp' ? 'success' : 'warning'"
                      dark
                      small
                      style="cursor:pointer;"
                      @click.stop="openPdfDialog(item)"
                    >
                      <v-icon left x-small>
                        {{
                          item.Mcommittee === "approp"
                            ? "mdi-check-circle"
                            : "mdi-close-circle"
                        }}
                      </v-icon>
                      {{
                        item.Mcommittee === "approp"
                          ? "เห็นควรให้รับย้าย"
                          : "ไม่เห็นควรให้รับย้าย"
                      }}
                    </v-chip>

                    <!-- ตรวจสอบความสมบูรณ์ -->
                    <v-chip
                      x-small
                      :color="isDataComplete(item) ? 'info' : 'error'"
                      dark
                    >
                      <v-icon x-small left>
                        {{
                          isDataComplete(item)
                            ? "mdi-check-all"
                            : "mdi-alert-circle"
                        }}
                      </v-icon>
                      {{
                        isDataComplete(item)
                          ? "ข้อมูลสมบูรณ์"
                          : "ข้อมูลไม่สมบูรณ์"
                      }}
                    </v-chip>

                    <!-- ปุ่มพิมพ์แบบเสนอความเห็น -->
                    <v-btn
                      x-small
                      color="error darken-1"
                      dark
                      @click.stop="printCommitteePdf(item)"
                      :loading="item._printing"
                    >
                      <v-icon x-small left>mdi-printer</v-icon> พิมพ์แบบเสนอ
                    </v-btn>

                    <!-- ปุ่มแก้ไข (เปิดระบบ) -->
                    <v-btn
                      v-if="isWithinPeriod"
                      x-small
                      color="warning darken-2"
                      @click.stop="
                        select_idPosition(
                          item.manage_id_ref,
                          item.manage_location_id_tfl
                        )
                      "
                    >
                      <v-icon x-small left>mdi-pencil</v-icon> แก้ไข
                    </v-btn>
                  </div>
                </template>
                <template v-else>
                  <v-icon
                    v-if="isWithinPeriod"
                    color="warning darken-2"
                    large
                    style="cursor:pointer;"
                    @click.stop="
                      select_idPosition(
                        item.manage_id_ref,
                        item.manage_location_id_tfl
                      )
                    "
                    >mdi-credit-card-plus</v-icon
                  >
                  <v-chip v-else color="grey" dark small>ปิดระบบแล้ว</v-chip>
                </template>
              </td>
              <!-- Log -->
              <td class="text-center">
                <v-btn icon x-small @click.stop="viewLog(item.manage_id_ref)">
                  <v-icon small color="info">mdi-history</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
          <v-alert
            slot="no-results"
            :value="true"
            color="error"
            icon="mdi-alert"
          >
            ไม่พบผลลัพธ์ "{{ search }}" ที่คุณกำลังค้นหา
          </v-alert>
        </v-data-table>
      </base-material-card>

      <!-- ══════════════════════════════════════════════════════
           Dialog: แบบบันทึกความเห็นคณะกรรมการสถานศึกษา
      ══════════════════════════════════════════════════════ -->
      <v-dialog v-model="positiondialog" persistent max-width="900">
        <v-card class="mx-auto">
          <base-material-card
            color="warning darken-2"
            icon="mdi-clipboard-check"
            title="แบบเสนอความเห็นคณะกรรมการสถานศึกษา"
            class="px-5 py-3 text_google"
          ></base-material-card>

          <v-card-text>
            <v-form ref="committeeForm" lazy-validation>
              <v-container>
                <!-- ── ส่วน 1: หัวเรื่อง ── -->
                <v-card outlined class="pa-3 mb-4" color="info lighten-5">
                  <div class="subtitle-1 font-weight-bold mb-2">
                    <v-icon left color="info">mdi-office-building</v-icon>
                    ข้อมูลการประชุม
                  </div>
                  <v-row dense>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="committeeForm.meeting_no"
                        label="ครั้งที่ประชุม *"
                        outlined
                        dense
                        placeholder="เช่น ๓/๒๕๖๘"
                        :rules="[v => !!v || 'กรุณาระบุครั้งที่ประชุม']"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-menu
                        v-model="meetingDateMenu"
                        :close-on-content-click="false"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="committeeForm.meeting_date"
                            label="วันที่ประชุม *"
                            outlined
                            dense
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            prepend-inner-icon="mdi-calendar"
                            :rules="[v => !!v || 'กรุณาเลือกวันที่ประชุม']"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="committeeForm.meeting_date"
                          locale="th"
                          @input="meetingDateMenu = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="committeeForm.doc_no"
                        label="เลขที่หนังสือนำส่ง *"
                        outlined
                        dense
                        placeholder="เช่น ศธ 0603.xx/xxx"
                        :rules="[v => !!v || 'กรุณาระบุเลขที่หนังสือ']"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-menu
                        v-model="docDateMenu"
                        :close-on-content-click="false"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="committeeForm.doc_date"
                            label="ลงวันที่ (หนังสือ) *"
                            outlined
                            dense
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            prepend-inner-icon="mdi-calendar"
                            :rules="[v => !!v || 'กรุณาเลือกวันที่หนังสือ']"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="committeeForm.doc_date"
                          locale="th"
                          @input="docDateMenu = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                </v-card>

                <!-- ── ส่วน 2: ข้อมูลผู้ยื่นคำร้อง ── -->
                <v-card outlined class="pa-3 mb-4">
                  <div class="subtitle-1 font-weight-bold mb-2">
                    <v-icon left color="info">mdi-account</v-icon>
                    ข้อมูลผู้ยื่นคำร้องขอย้าย
                  </div>
                  <v-row dense>
                    <v-col cols="12" md="6">
                      <v-text-field
                        :value="fullname"
                        label="ชื่อ – นามสกุล"
                        outlined
                        dense
                        readonly
                        filled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        :value="transference_manages_id_ref.id_position"
                        label="ตำแหน่ง / เลขที่ตำแหน่ง"
                        outlined
                        dense
                        readonly
                        filled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        :value="transference_manages_id_ref.college_name"
                        label="สังกัด (สถานศึกษาปัจจุบัน)"
                        outlined
                        dense
                        readonly
                        filled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-text-field
                        :value="
                          transference_manage_location_s.manage_location_sequence_n
                        "
                        label="ขอย้ายลำดับที่"
                        outlined
                        dense
                        readonly
                        filled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-text-field
                        :value="
                          periods.period_college_times +
                            '/' +
                            periodCollegeYearBE
                        "
                        label="ครั้งที่/ปี"
                        outlined
                        dense
                        readonly
                        filled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-card elevation="1" class="pa-2" color="grey lighten-5">
                        <div class="caption grey--text">เหตุผลในการย้าย</div>
                        <div class="body-2">
                          {{
                            transference_manage_location_s.manage_reason_detail
                          }}
                        </div>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card>

                <!-- ── ส่วน 3: ความเห็นคณะกรรมการฯ ── -->
                <v-card outlined class="pa-3 mb-4" color="info lighten-5">
                  <div class="subtitle-1 font-weight-bold mb-2">
                    <v-icon left color="info darken-2">mdi-vote</v-icon>
                    ความเห็นคณะกรรมการสถานศึกษา *
                  </div>
                  <v-radio-group
                    v-model="committeeForm.Mcommittee"
                    row
                    required
                    :rules="[v => !!v || 'กรุณาเลือกความเห็น']"
                    class="mb-0"
                  >
                    <v-radio value="approp">
                      <template v-slot:label>
                        <v-chip color="success" dark small>
                          <v-icon left x-small>mdi-check-circle</v-icon>
                          เห็นควรให้รับย้าย
                        </v-chip>
                      </template>
                    </v-radio>
                    <v-radio value="inapprop">
                      <template v-slot:label>
                        <v-chip color="warning" dark small>
                          <v-icon left x-small>mdi-close-circle</v-icon>
                          ไม่เห็นควรให้รับย้าย
                        </v-chip>
                      </template>
                    </v-radio>
                  </v-radio-group>

                  <!-- เหตุผลไม่เห็นชอบ (แสดงเมื่อเลือก inapprop) -->
                  <v-expand-transition>
                    <div v-if="committeeForm.Mcommittee === 'inapprop'">
                      <v-textarea
                        v-model="committeeForm.committee_reason"
                        label="เหตุผลที่ไม่เห็นควร *"
                        outlined
                        dense
                        rows="4"
                        placeholder="ระบุเหตุผลที่คณะกรรมการฯ ไม่เห็นควรให้รับย้าย"
                        :rules="[
                          v =>
                            committeeForm.Mcommittee !== 'inapprop' ||
                            !!v ||
                            'กรุณาระบุเหตุผล'
                        ]"
                      ></v-textarea>
                    </div>
                  </v-expand-transition>

                  <!-- หมายเหตุ (ใช้ได้ทั้ง 2 ฝั่ง) -->
                  <v-textarea
                    v-model="committeeForm.committee_remark"
                    label="หมายเหตุ (ถ้ามี)"
                    outlined
                    dense
                    rows="2"
                    placeholder="หมายเหตุเพิ่มเติม หรือข้อสังเกตของคณะกรรมการ"
                  ></v-textarea>
                </v-card>

                <!-- ── ส่วน 4: ผู้ลงนาม (ประธานกรรมการ) ── -->
                <v-card outlined class="pa-3 mb-4">
                  <div class="subtitle-1 font-weight-bold mb-2">
                    <v-icon left color="primary">mdi-pen</v-icon>
                    ข้อมูลผู้ลงนาม (ประธานกรรมการสถานศึกษา)
                  </div>
                  <v-row dense>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="committeeForm.chairman_title"
                        label="คำนำหน้าชื่อ *"
                        outlined
                        dense
                        placeholder="เช่น นาย / นาง / นางสาว"
                        :rules="[v => !!v || 'กรุณาระบุคำนำหน้า']"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="committeeForm.chairman_firstname"
                        label="ชื่อ *"
                        outlined
                        dense
                        :rules="[v => !!v || 'กรุณาระบุชื่อ']"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="committeeForm.chairman_lastname"
                        label="นามสกุล *"
                        outlined
                        dense
                        :rules="[v => !!v || 'กรุณาระบุนามสกุล']"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="8">
                      <v-text-field
                        v-model="committeeForm.chairman_position"
                        label="ตำแหน่งประธานกรรมการ"
                        outlined
                        dense
                        placeholder="เช่น ประธานกรรมการสถานศึกษา"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-card>

                <!-- ── ส่วน 5: แนบไฟล์วาระ/ผลการประชุม ── -->
                <v-card outlined class="pa-3 mb-4">
                  <div class="subtitle-1 font-weight-bold mb-2">
                    <v-icon left color="error darken-2">mdi-file-pdf-box</v-icon>
                    แนบไฟล์ผลการพิจารณา (PDF เท่านั้น)
                  </div>
                  <v-alert dense outlined type="info" class="mb-2">
                    รวม: หนังสือนำส่ง + วาระการประชุม + ผลการพิจารณา เป็น
                    <strong>1 ไฟล์ PDF</strong>
                  </v-alert>

                  <!-- แสดงไฟล์เดิม (กรณีแก้ไข) -->
                  <div v-if="existingFile && !replaceFile" class="mb-3">
                    <v-alert
                      dense
                      type="success"
                      outlined
                      class="d-flex align-center"
                    >
                      <v-icon left>mdi-check-circle</v-icon>
                      มีไฟล์แนบอยู่แล้ว:
                      <strong class="ml-1">{{ existingFile }}</strong>
                      <v-spacer></v-spacer>
                      <v-btn
                        x-small
                        color="info"
                        text
                        @click="openExistingFile"
                      >
                        <v-icon x-small left>mdi-eye</v-icon>ดูไฟล์
                      </v-btn>
                      <v-btn
                        x-small
                        color="warning"
                        text
                        @click="replaceFile = true"
                      >
                        <v-icon x-small left>mdi-swap-horizontal</v-icon
                        >เปลี่ยนไฟล์
                      </v-btn>
                    </v-alert>
                  </div>

                  <v-file-input
                    v-if="!existingFile || replaceFile"
                    v-model="documentsLinkfiles"
                    accept=".pdf"
                    color="primary"
                    counter
                    label="เลือกไฟล์ .pdf"
                    placeholder="คลิกเพื่อเลือกไฟล์ PDF"
                    prepend-icon="mdi-paperclip"
                    outlined
                    dense
                    rounded
                    :show-size="1000"
                    :rules="fileRules"
                  >
                    <template v-slot:selection="{ index, text }">
                      <v-chip
                        v-if="index < 2"
                        color="primary"
                        dark
                        label
                        small
                        >{{ text }}</v-chip
                      >
                    </template>
                  </v-file-input>

                  <v-btn
                    v-if="replaceFile"
                    x-small
                    text
                    color="grey"
                    @click="
                      replaceFile = false;
                      documentsLinkfiles = null;
                    "
                  >
                    <v-icon x-small left>mdi-close</v-icon>ยกเลิกการเปลี่ยนไฟล์
                  </v-btn>
                </v-card>

                <!-- ── ตรวจสอบความสมบูรณ์ก่อนบันทึก ── -->
                <v-card outlined class="pa-2 mb-2" color="grey lighten-4">
                  <div class="subtitle-2 mb-1">
                    <v-icon small left>mdi-check-decagram</v-icon>
                    รายการตรวจสอบก่อนบันทึก
                  </div>
                  <v-row dense>
                    <v-col
                      v-for="check in validationChecks"
                      :key="check.label"
                      cols="12"
                      md="6"
                    >
                      <div class="d-flex align-center caption">
                        <v-icon
                          small
                          :color="check.ok ? 'success' : 'error'"
                          class="mr-1"
                        >
                          {{
                            check.ok ? "mdi-check-circle" : "mdi-circle-outline"
                          }}
                        </v-icon>
                        {{ check.label }}
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-container>
            </v-form>
          </v-card-text>

          <v-divider></v-divider>
          <v-card-actions>
            <v-btn large rounded @click.stop="closePositionDialog">
              <v-icon dark>mdi-close</v-icon> ปิด
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              large
              color="success darken-1"
              dark
              rounded
              @click.stop="updatepositionSubmit"
              :loading="saving"
              :disabled="!allChecksPass"
            >
              <v-icon dark left>mdi-content-save</v-icon>
              {{ isEditMode ? "บันทึกการแก้ไข" : "บันทึก" }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- ══════════════════════════════════════════════════════
           Dialog: ยกเลิกความเห็น
      ══════════════════════════════════════════════════════ -->
      <v-dialog v-model="cancelOpinionDialog" persistent max-width="500">
        <v-card>
          <base-material-card
            color="error"
            icon="mdi-undo-variant"
            title="ยกเลิกความเห็นของสถานศึกษา"
            class="px-5 py-3"
          ></base-material-card>
          <v-card-text>
            <v-alert type="warning" prominent>
              <strong>คุณต้องการยกเลิกความเห็นนี้ใช่หรือไม่?</strong>
            </v-alert>
            <v-card outlined class="pa-3 mt-3" v-if="cancelOpinionItem">
              <div>
                <strong>รหัสอ้างอิง:</strong>
                {{ cancelOpinionItem.manage_id_ref }}
              </div>
              <div>
                <strong>ชื่อ:</strong>
                {{ cancelOpinionItem.title_s
                }}{{ cancelOpinionItem.frist_name }}
                {{ cancelOpinionItem.last_name }}
              </div>
              <div>
                <strong>ความเห็นเดิม:</strong>
                <v-chip
                  small
                  dark
                  class="ml-2"
                  :color="
                    cancelOpinionItem.Mcommittee === 'approp'
                      ? 'success'
                      : 'warning'
                  "
                >
                  {{
                    cancelOpinionItem.Mcommittee === "approp"
                      ? "เห็นควรให้รับย้าย"
                      : "ไม่เห็นควรให้รับย้าย"
                  }}
                </v-chip>
              </div>
            </v-card>
            <v-textarea
              v-model="cancelReason"
              label="เหตุผลในการยกเลิก *"
              outlined
              rows="3"
              class="mt-4"
              :rules="[v => !!v || 'กรุณาระบุเหตุผล']"
            ></v-textarea>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn large rounded @click.stop="cancelOpinionDialog = false">
              <v-icon dark>mdi-close</v-icon> ปิด
            </v-btn>
            <v-btn
              large
              color="error"
              dark
              rounded
              :loading="cancelling"
              @click.stop="submitCancelOpinion"
            >
              <v-icon dark left>mdi-undo-variant</v-icon> ยืนยันยกเลิก
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- ══════════════════════════════════════════════════════
           Dialog: ดู PDF (Fullscreen)
      ══════════════════════════════════════════════════════ -->
      <v-dialog
        v-model="pdfDialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card
          tile
          style="position:fixed; top:0; left:0; right:0; bottom:0; margin:0; border-radius:0; overflow:hidden;"
        >
          <v-toolbar
            id="pdf-toolbar"
            dense
            flat
            dark
            :color="pdfMode === 'form' ? 'info darken-3' : 'info darken-4'"
          >
            <v-icon class="mr-2">
              {{
                pdfMode === "form"
                  ? "mdi-clipboard-account"
                  : "mdi-file-pdf-box"
              }}
            </v-icon>
            <v-toolbar-title
              class="subtitle-1 font-weight-medium"
              v-if="pdfItem"
            >
              <template v-if="pdfMode === 'form'">
                แบบเสนอย้าย — {{ pdfItem.title_s }}{{ pdfItem.frist_name }}
                {{ pdfItem.last_name }}
              </template>
              <template v-else>
                ไฟล์ผลการพิจารณา — {{ pdfItem.title_s
                }}{{ pdfItem.frist_name }} {{ pdfItem.last_name }}
              </template>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon :href="pdfUrl" target="_blank"
              ><v-icon>mdi-open-in-new</v-icon></v-btn
            >
            <v-btn icon :href="pdfUrl" :download="pdfDownloadName"
              ><v-icon>mdi-download</v-icon></v-btn
            >
            <v-btn icon @click="closePdfDialog"
              ><v-icon>mdi-close</v-icon></v-btn
            >
          </v-toolbar>

          <v-sheet
            id="pdf-infobar"
            dark
            class="px-4 py-1"
            :color="pdfMode === 'form' ? 'info darken-2' : 'info darken-3'"
            v-if="pdfItem"
          >
            <v-row dense align="center">
              <v-col cols="auto">
                <v-icon small class="mr-1">mdi-identifier</v-icon>
                <span class="caption">รหัสอ้างอิง:</span>
                <strong class="ml-1 body-2">{{ pdfItem.manage_id_ref }}</strong>
              </v-col>
              <v-divider vertical class="mx-3 my-1"></v-divider>
              <v-col cols="auto">
                <v-icon small class="mr-1">mdi-school</v-icon>
                <span class="caption">สถานศึกษาปัจจุบัน:</span>
                <strong class="ml-1 body-2">{{
                  pdfItem.college_name_now
                }}</strong>
              </v-col>
              <template v-if="pdfMode !== 'form' && pdfItem.Mcommittee">
                <v-divider vertical class="mx-3 my-1"></v-divider>
                <v-col cols="auto">
                  <span class="caption">ความเห็น:</span>
                  <v-chip
                    x-small
                    dark
                    class="ml-1 font-weight-bold"
                    :color="
                      pdfItem.Mcommittee === 'approp' ? 'success' : 'warning'
                    "
                  >
                    {{
                      pdfItem.Mcommittee === "approp"
                        ? "เห็นควรให้รับย้าย"
                        : "ไม่เห็นควรให้รับย้าย"
                    }}
                  </v-chip>
                </v-col>
              </template>
            </v-row>
          </v-sheet>

          <div
            style="position:absolute; top:84px; left:0; right:0; bottom:44px; background:#525659; overflow:hidden;"
          >
            <v-overlay
              absolute
              :value="pdfLoading"
              color="grey darken-4"
              opacity="0.85"
            >
              <div class="text-center">
                <v-progress-circular
                  indeterminate
                  size="56"
                  width="4"
                  color="white"
                ></v-progress-circular>
                <div class="mt-3 white--text body-1">กำลังโหลดไฟล์ PDF...</div>
              </div>
            </v-overlay>

            <div
              v-if="pdfLoadError"
              class="d-flex flex-column align-center justify-center"
              style="height:100%; color:white;"
            >
              <v-icon size="80" color="error lighten-2">mdi-file-pdf-box</v-icon>
              <div class="headline mt-4 mb-2">ไม่สามารถแสดงไฟล์ PDF ได้</div>
              <div class="d-flex" style="gap:12px;">
                <v-btn color="primary" :href="pdfUrl" target="_blank" rounded>
                  <v-icon left>mdi-open-in-new</v-icon> เปิดในแท็บใหม่
                </v-btn>
                <v-btn
                  color="success"
                  :href="pdfUrl"
                  :download="pdfDownloadName"
                  rounded
                >
                  <v-icon left>mdi-download</v-icon> ดาวน์โหลด
                </v-btn>
              </div>
            </div>

            <iframe
              v-if="pdfDialog && pdfUrl && !pdfLoadError"
              :src="pdfUrl"
              width="100%"
              height="100%"
              style="border:none; display:block; position:absolute; top:0; left:0;"
              type="application/pdf"
              @load="onPdfLoad"
              @error="onPdfError"
            ></iframe>
          </div>

          <v-sheet
            dark
            class="px-4"
            style="position:absolute; bottom:0; left:0; right:0; height:44px; display:flex; align-items:center; justify-content:flex-end;"
            :color="pdfMode === 'form' ? 'info darken-2' : 'info darken-3'"
          >
            <v-btn
              v-if="pdfMode === 'assessment' && pdfItem && isWithinPeriod"
              color="warning darken-2"
              dark
              small
              rounded
              class="mr-2"
              @click="closePdfAndEdit(pdfItem)"
            >
              <v-icon small left>mdi-pencil</v-icon> แก้ไขความเห็น
            </v-btn>
            <v-btn color="white" text rounded @click="closePdfDialog">
              <v-icon left>mdi-close</v-icon> ปิด
            </v-btn>
          </v-sheet>
        </v-card>
      </v-dialog>

      <!-- ══════════════════════════════════════════════════════
           Dialog: พรีวิว/พิมพ์ แบบเสนอความเห็นคณะกรรมการสถานศึกษา
      ══════════════════════════════════════════════════════ -->
      <v-dialog
        v-model="printPreviewDialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card
          tile
          style="position:fixed; top:0; left:0; right:0; bottom:0; margin:0; border-radius:0; overflow:hidden;"
        >
          <!-- Toolbar -->
          <v-toolbar dense flat dark color="error darken-3">
            <v-icon class="mr-2">mdi-file-document-outline</v-icon>
            <v-toolbar-title class="subtitle-1 font-weight-medium">
              แบบเสนอความเห็นคณะกรรมการสถานศึกษา
              <span v-if="printPreviewItem" class="ml-2 caption">
                — {{ printPreviewItem.title_s
                }}{{ printPreviewItem.frist_name }}
                {{ printPreviewItem.last_name }}
              </span>
              <span v-if="printPreviewMode === 'all'" class="ml-2 caption">
                — ทั้งหมด {{ transference_manage_locations.length }} รายการ
              </span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <!-- เปิดในแท็บใหม่ -->
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon :href="printPreviewUrl" target="_blank" v-on="on">
                  <v-icon>mdi-open-in-new</v-icon>
                </v-btn>
              </template>
              <span>เปิดในแท็บใหม่</span>
            </v-tooltip>
            <!-- ดาวน์โหลด -->
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  :href="printPreviewUrl"
                  :download="printPreviewFilename"
                  v-on="on"
                >
                  <v-icon>mdi-download</v-icon>
                </v-btn>
              </template>
              <span>ดาวน์โหลด PDF</span>
            </v-tooltip>
            <v-btn icon @click="closePrintPreview"
              ><v-icon>mdi-close</v-icon></v-btn
            >
          </v-toolbar>

          <!-- Info bar -->
          <v-sheet dark class="px-4 py-1" color="error darken-2">
            <v-row dense align="center">
              <v-col cols="auto">
                <v-icon small class="mr-1">mdi-printer</v-icon>
                <span class="caption">เอกสาร:</span>
                <strong class="ml-1 body-2"
                  >แบบเสนอความเห็นคณะกรรมการสถานศึกษา</strong
                >
              </v-col>
              <v-divider vertical class="mx-3 my-1"></v-divider>
              <v-col cols="auto">
                <v-icon small class="mr-1">mdi-information-outline</v-icon>
                <span class="caption"
                  >พิมพ์เอกสาร → ลงนาม → สแกนแนบกลับระบบ</span
                >
              </v-col>
              <v-spacer></v-spacer>
              <!-- ปุ่มสำหรับแนบไฟล์โดยตรงจาก dialog นี้ -->
              <v-col cols="auto" v-if="printPreviewItem && isWithinPeriod">
                <v-btn
                  x-small
                  color="warning darken-2"
                  dark
                  rounded
                  @click="closePrintAndUpload(printPreviewItem)"
                >
                  <v-icon x-small left>mdi-upload</v-icon> แนบไฟล์ที่สแกนแล้ว
                </v-btn>
              </v-col>
            </v-row>
          </v-sheet>

          <!-- PDF Viewer -->
          <div
            style="position:absolute; top:84px; left:0; right:0; bottom:44px; background:#525659; overflow:hidden;"
          >
            <v-overlay
              absolute
              :value="printPreviewLoading"
              color="grey darken-4"
              opacity="0.85"
            >
              <div class="text-center">
                <v-progress-circular
                  indeterminate
                  size="56"
                  width="4"
                  color="white"
                ></v-progress-circular>
                <div class="mt-3 white--text body-1">
                  กำลังสร้างเอกสาร PDF...
                </div>
              </div>
            </v-overlay>

            <div
              v-if="printPreviewError"
              class="d-flex flex-column align-center justify-center"
              style="height:100%; color:white;"
            >
              <v-icon size="80" color="error lighten-2">mdi-file-pdf-box</v-icon>
              <div class="headline mt-4 mb-2">ไม่สามารถแสดงเอกสารได้</div>
              <v-btn
                color="primary"
                :href="printPreviewUrl"
                target="_blank"
                rounded
                class="mt-3"
              >
                <v-icon left>mdi-open-in-new</v-icon> เปิดในแท็บใหม่
              </v-btn>
            </div>

            <iframe
              v-if="printPreviewDialog && printPreviewUrl && !printPreviewError"
              :src="'https://hrvec.ovec.go.th/HRvec_api/' + printPreviewUrl"
              width="100%"
              height="100%"
              style="border:none; display:block; position:absolute; top:0; left:0;"
              type="application/pdf"
              @load="printPreviewLoading = false"
              @error="
                printPreviewLoading = false;
                printPreviewError = true;
              "
            ></iframe>
          </div>

          <!-- Footer -->
          <v-sheet
            dark
            class="px-4"
            style="position:absolute; bottom:0; left:0; right:0; height:44px; display:flex; align-items:center; justify-content:flex-end;"
            color="error darken-2"
          >
            <v-btn color="white" text rounded @click="closePrintPreview">
              <v-icon left>mdi-close</v-icon> ปิด
            </v-btn>
          </v-sheet>
        </v-card>
      </v-dialog>

      <!-- ══════════════════════════════════════════════════════
           Dialog: Log การดำเนินการ
      ══════════════════════════════════════════════════════ -->
      <v-dialog v-model="logDialog" max-width="900">
        <v-card>
          <base-material-card
            color="info"
            icon="mdi-history"
            title="Log การดำเนินการ"
            class="px-5 py-3"
          ></base-material-card>
          <v-card-text>
            <v-data-table
              :headers="logHeaders"
              :items="actionLogs"
              dense
              :items-per-page="10"
            >
              <template v-slot:item.log_action="{ item }">
                <v-chip small :color="getLogColor(item.log_action)" dark>{{
                  item.log_action
                }}</v-chip>
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="logDialog = false" rounded>ปิด</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>

    <!-- Snackbar -->
    <v-snackbar
      v-model="snackbar.show"
      top
      :timeout="snackbar.timeout"
      :color="snackbar.color"
    >
      <v-icon large left>{{ snackbar.icon }}</v-icon>
      <span>{{ snackbar.text }}</span>
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.show = false">Close</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
      saving: false,
      cancelling: false,
      ApiKey: "HRvec2021",

      // ── ข้อมูลหลัก ──
      transference_manage_locations: [],
      periods: {},
      transference_manages_id_ref: {},
      transference_manage_location_s: {},
      colleges: [],

      // ── Dialog flags ──
      positiondialog: false,
      cancelOpinionDialog: false,
      pdfDialog: false,
      logDialog: false,

      // ── ค้นหา / กรอง ──
      search: "",
      filterStatus: "all",

      // ── PDF ──
      pdfItem: null,
      pdfUrl: "",
      pdfLoading: false,
      pdfLoadError: false,
      pdfMode: "form",

      // ── ยกเลิก ──
      cancelOpinionItem: null,
      cancelReason: "",

      // ── ฟอร์มกรอกความเห็น ──
      committeeForm: {
        Mcommittee: "",
        committee_reason: "",
        committee_remark: "",
        meeting_no: "",
        meeting_date: "",
        doc_no: "",
        doc_date: "",
        chairman_title: "",
        chairman_firstname: "",
        chairman_lastname: "",
        chairman_position: "ประธานกรรมการสถานศึกษา"
      },

      // ── ไฟล์แนบ ──
      documentsLinkfiles: null,
      existingFile: "",
      replaceFile: false,
      isEditMode: false,

      // ── DatePicker ──
      meetingDateMenu: false,
      docDateMenu: false,

      // ── Print Preview ──
      printPreviewDialog: false,
      printPreviewUrl: "",
      printPreviewFilename: "committee_opinion.pdf",
      printPreviewLoading: false,
      printPreviewError: false,
      printPreviewItem: null,
      printPreviewMode: "single", // 'single' | 'all'
      printingAll: false,

      // ── Snackbar ──
      snackbar: {
        show: false,
        color: "",
        timeout: 5000,
        icon: "",
        text: ""
      },

      // ── Table headers ──
      headers: [
        { text: "#", align: "center", value: "index", width: 50 },
        { text: "Ref", align: "center", value: "manage_id_ref", width: 90 },
        { text: "ชื่อ – นามสกุล", align: "left", value: "frist_name" },
        { text: "ส.ปัจจุบัน", align: "left", value: "college_name_now" },
        { text: "ครั้งที่/ปี", align: "center", value: "time_ss", width: 80 },
        {
          text: "อายุงาน",
          align: "center",
          value: "manage_age_app_time",
          width: 80
        },
        {
          text: "ลำดับ",
          align: "center",
          value: "manage_location_sequence_n",
          width: 70
        },
        {
          text: "แบบเสนอย้าย",
          align: "center",
          value: "printmidRef",
          sortable: false,
          width: 80
        },
        {
          text: "ความเห็นกรรมการสถานศึกษา",
          align: "center",
          value: "Mcommittee",
          width: 220
        },
        {
          text: "Log",
          align: "center",
          value: "log",
          sortable: false,
          width: 60
        }
      ],
      logHeaders: [
        { text: "#", value: "log_id", align: "center", width: 50 },
        { text: "รหัสอ้างอิง", value: "log_manage_id_ref", align: "center" },
        { text: "การดำเนินการ", value: "log_action", align: "center" },
        { text: "ความเห็น", value: "log_committee", align: "center" },
        { text: "เหตุผล/หมายเหตุ", value: "log_remark", align: "left" },
        { text: "ผู้ดำเนินการ", value: "log_user", align: "center" },
        { text: "วันเวลา", value: "log_datetime", align: "center" }
      ],
      actionLogs: []
    };
  },

  computed: {
    // ── แปลงปี period_college_year → ค.ศ. 4 หลัก (ป้องกัน | yearFormat filter) ──
    periodCollegeYearBE() {
      const y = this.periods.period_college_year;
      if (!y) return "";
      // รองรับทั้ง "2568-01-01", 2568, "2568"
      const str = String(y)
        .trim()
        .slice(0, 4);
      const num = parseInt(str, 10);
      return isNaN(num) ? "" : num;
    },

    isWithinPeriod() {
      const flag = this.periods.period_college_enable_file;
      if (!flag || (flag != 1 && flag != "1")) return false;
      const now = new Date();
      const stop = this.periods.period_college_stop
        ? new Date(this.periods.period_college_stop)
        : null;
      if (stop) stop.setHours(23, 59, 59, 999);
      return !(stop && now > stop);
    },

    fullname() {
      const p = this.transference_manages_id_ref;
      if (!p || !p.frist_name) return "";
      return `${p.title_s || ""}${p.frist_name} ${p.last_name}`;
    },

    pdfDownloadName() {
      if (!this.pdfItem) return "document.pdf";
      return this.pdfMode === "form"
        ? `${this.pdfItem.manage_id_ref}_แบบเสนอย้าย.pdf`
        : `${this.pdfItem.manage_id_ref}_ผลการพิจารณา.pdf`;
    },

    filteredItems() {
      let items = this.transference_manage_locations || [];
      if (this.filterStatus === "approp")
        return items.filter(i => i.Mcommittee === "approp");
      if (this.filterStatus === "inapprop")
        return items.filter(i => i.Mcommittee === "inapprop");
      if (this.filterStatus === "pending")
        return items.filter(i => !i.Mcommittee);
      if (this.filterStatus === "incomplete")
        return items.filter(i => i.Mcommittee && !this.isDataComplete(i));
      return items;
    },

    countApprop() {
      return (this.transference_manage_locations || []).filter(
        i => i.Mcommittee === "approp"
      ).length;
    },
    countInapprop() {
      return (this.transference_manage_locations || []).filter(
        i => i.Mcommittee === "inapprop"
      ).length;
    },
    countPending() {
      return (this.transference_manage_locations || []).filter(
        i => !i.Mcommittee
      ).length;
    },

    // ── rules ไฟล์ PDF: บังคับเฉพาะเพิ่มใหม่ หรือเมื่อเปลี่ยนไฟล์ ──
    fileRules() {
      if (!this.existingFile || this.replaceFile) {
        return [v => !!v || "กรุณาแนบไฟล์ PDF"];
      }
      return [];
    },

    // ── รายการตรวจสอบ ──
    validationChecks() {
      const f = this.committeeForm;
      return [
        { label: "เลือกความเห็น", ok: !!f.Mcommittee },
        {
          label: "ระบุเหตุผล (กรณีไม่เห็นชอบ)",
          ok: f.Mcommittee !== "inapprop" || !!f.committee_reason
        },
        { label: "ครั้งที่ประชุม", ok: !!f.meeting_no },
        { label: "วันที่ประชุม", ok: !!f.meeting_date },
        { label: "เลขที่หนังสือนำส่ง", ok: !!f.doc_no },
        { label: "วันที่หนังสือ", ok: !!f.doc_date },
        {
          label: "ชื่อประธานกรรมการ",
          ok: !!(f.chairman_firstname && f.chairman_lastname)
        },
        {
          label: "แนบไฟล์ PDF",
          ok: !!this.existingFile || !!this.documentsLinkfiles
        }
      ];
    },

    allChecksPass() {
      return this.validationChecks.every(c => c.ok);
    }
  },

  async mounted() {
    let result;
    result = await this.$http.post("college.php", { ApiKey: this.ApiKey });
    this.colleges = result.data;
    await this.periodQuery();
  },

  methods: {
    // ─────────────────────────────────────────────
    // Init
    // ─────────────────────────────────────────────
    async periodQuery() {
      let result = await this.$http.post("period_college.php", {
        ApiKey: this.ApiKey,
        period_college_id: "40103"
      });
      this.periods = result.data;

      const flag = this.periods.period_college_enable_file;
      if (flag != 1 && flag != "1") {
        Swal.fire({
          icon: "error",
          title: "ยังไม่มีกำหนดการ",
          allowOutsideClick: false,
          allowEscapeKey: false
        }).then(r => {
          if (r.isConfirmed) this.$router.push("/college");
        });
      } else {
        await this.transference_manage_locationQueryAll();
      }
    },

    async transference_manage_locationQueryAll() {
      this.loading = true;
      let userSession = JSON.parse(localStorage.getItem("user")) || {};
      let result = await this.$http
        .post("transference_manage_location.php", {
          ApiKey: this.ApiKey,
          manage_time_s: this.periods.period_college_times,
          manage_year_s: this.periods.period_college_year,
          manage_location_college_code: userSession.user_name
        })
        .finally(() => (this.loading = false));
      this.transference_manage_locations = result.data || [];
    },

    // ─────────────────────────────────────────────
    // เปิด Dialog กรอก/แก้ไขความเห็น
    // ─────────────────────────────────────────────
    async select_idPosition(manage_id_ref, manage_location_id_tfl) {
      if (!this.isWithinPeriod) {
        this.showSnackbar("error", "mdi-lock", "ระบบปิดรับการบันทึกแล้ว");
        return;
      }

      // โหลดข้อมูลผู้ยื่นหลัก
      let r1 = await this.$http.post("transference_manage.php", {
        ApiKey: this.ApiKey,
        manage_id_ref
      });
      this.transference_manages_id_ref = r1.data || {};

      // โหลดข้อมูล location (ปลายทาง)
      let r2 = await this.$http.post("transference_manage_location.php", {
        ApiKey: this.ApiKey,
        manage_location_id_tfl
      });
      this.transference_manage_location_s = r2.data || {};

      // ตั้งค่า form — ถ้ามีข้อมูลเดิม ให้โหลดเข้า form (edit mode)
      const loc = this.transference_manage_location_s;
      this.isEditMode = !!loc.Mcommittee;
      this.existingFile = loc.MdocumentsLinkfile || "";
      this.replaceFile = false;
      this.documentsLinkfiles = null;

      this.committeeForm = {
        Mcommittee: loc.Mcommittee || "",
        committee_reason: loc.committee_reason || "",
        committee_remark: loc.committee_remark || "",
        meeting_no: loc.committee_meeting_no || "",
        meeting_date: loc.committee_meeting_date
          ? loc.committee_meeting_date.split(" ")[0]
          : "",
        doc_no: loc.committee_doc_no || "",
        doc_date: loc.committee_doc_date
          ? loc.committee_doc_date.split(" ")[0]
          : "",
        chairman_title: loc.committee_chairman_title || "",
        chairman_firstname: loc.committee_chairman_firstname || "",
        chairman_lastname: loc.committee_chairman_lastname || "",
        chairman_position:
          loc.committee_chairman_position || "ประธานกรรมการสถานศึกษา"
      };

      this.positiondialog = true;
    },

    closePositionDialog() {
      this.positiondialog = false;
      this.$nextTick(() => {
        if (this.$refs.committeeForm)
          this.$refs.committeeForm.resetValidation();
      });
    },

    // ─────────────────────────────────────────────
    // บันทึกความเห็น
    // ─────────────────────────────────────────────
    async updatepositionSubmit() {
      if (!this.isWithinPeriod) {
        this.showSnackbar("error", "mdi-lock", "ระบบปิดรับการบันทึกแล้ว");
        return;
      }
      if (!this.$refs.committeeForm.validate()) {
        this.showSnackbar("warning", "mdi-alert", "กรุณากรอกข้อมูลให้ครบถ้วน");
        return;
      }

      this.saving = true;
      let userSession = JSON.parse(localStorage.getItem("user")) || {};
      const loc = this.transference_manage_location_s;

      // ── upload ไฟล์ ──
      let uploadedFilename = this.existingFile || "";
      if (this.documentsLinkfiles) {
        let formData = new FormData();
        let filename =
          loc.manage_id_ref + userSession.user_name + "collegeAssessment.pdf";
        formData.append("ApiKey", this.ApiKey);
        formData.append("file", this.documentsLinkfiles);
        formData.append("filename", "../HRvecfiles/" + filename);
        try {
          let uploadResult = await this.$http.post("uploadfile.php", formData, {
            headers: { "Content-Type": "multipart/form-data" }
          });
          if (uploadResult.data.status) {
            uploadedFilename = filename;
          } else {
            this.showSnackbar("warning", "mdi-alert", "อัพโหลดไฟล์ไม่สำเร็จ");
            this.saving = false;
            return;
          }
        } catch (e) {
          this.showSnackbar(
            "error",
            "mdi-alert-circle",
            "เกิดข้อผิดพลาดในการอัพโหลดไฟล์"
          );
          this.saving = false;
          return;
        }
      }

      // ── บันทึกข้อมูล ──
      const payload = {
        ApiKey: this.ApiKey,
        manage_location_id_tfl: loc.manage_location_id_tfl,
        manage_location_id_ref: loc.manage_id_ref,
        manage_location_college_code: userSession.user_name,
        // ข้อมูลเดิม
        Mcommittee: this.committeeForm.Mcommittee,
        MdocumentsLinkfile: uploadedFilename,
        manage_location_status_transfer: this.committeeForm.Mcommittee,
        // ข้อมูลใหม่
        committee_reason: this.committeeForm.committee_reason,
        committee_remark: this.committeeForm.committee_remark,
        committee_meeting_no: this.committeeForm.meeting_no,
        committee_meeting_date: this.committeeForm.meeting_date,
        committee_doc_no: this.committeeForm.doc_no,
        committee_doc_date: this.committeeForm.doc_date,
        committee_chairman_title: this.committeeForm.chairman_title,
        committee_chairman_firstname: this.committeeForm.chairman_firstname,
        committee_chairman_lastname: this.committeeForm.chairman_lastname,
        committee_chairman_position: this.committeeForm.chairman_position
      };

      try {
        let saveResult = await this.$http.post(
          "transference_manage_location.update.php",
          payload
        );

        if (saveResult.data.status) {
          await this.writeLog({
            manage_id_ref: loc.manage_id_ref,
            action: this.isEditMode ? "แก้ไขความเห็น" : "บันทึกความเห็น",
            committee: this.committeeForm.Mcommittee,
            remark:
              (this.isEditMode ? "แก้ไข" : "บันทึก") +
              "ความเห็น" +
              (uploadedFilename ? " พร้อมแนบไฟล์" : ""),
            user: userSession.user_name
          });

          Swal.fire({
            icon: "success",
            title: this.isEditMode
              ? "แก้ไขข้อมูลเรียบร้อย"
              : "บันทึกข้อมูลเรียบร้อย",
            showConfirmButton: false,
            timer: 1500
          });
          this.transference_manage_locationQueryAll();
          this.closePositionDialog();
        } else {
          Swal.fire({
            icon: "warning",
            title: "บันทึกข้อมูลผิดพลาด",
            showConfirmButton: false,
            timer: 1500
          });
        }
      } catch (e) {
        Swal.fire({ icon: "error", title: "เกิดข้อผิดพลาด", text: e.message });
      } finally {
        this.saving = false;
      }
    },

    // ─────────────────────────────────────────────
    // ยกเลิกความเห็น
    // ─────────────────────────────────────────────
    openCancelOpinionDialog(item) {
      if (!this.isWithinPeriod) {
        this.showSnackbar("error", "mdi-lock", "ระบบปิดรับการยกเลิกแล้ว");
        return;
      }
      this.cancelOpinionItem = item;
      this.cancelReason = "";
      this.cancelOpinionDialog = true;
    },

    async submitCancelOpinion() {
      if (!this.cancelReason || !this.cancelReason.trim()) {
        this.showSnackbar("warning", "mdi-alert", "กรุณาระบุเหตุผลในการยกเลิก");
        return;
      }
      if (!this.isWithinPeriod) {
        this.showSnackbar("error", "mdi-lock", "ระบบปิดรับการยกเลิกแล้ว");
        return;
      }

      this.cancelling = true;
      let userSession = JSON.parse(localStorage.getItem("user")) || {};
      try {
        let result = await this.$http.post(
          "transference_manage_location.update.php",
          {
            ApiKey: this.ApiKey,
            manage_location_id_ref: this.cancelOpinionItem.manage_id_ref,
            manage_location_college_code: userSession.user_name,
            Mcommittee: "",
            MdocumentsLinkfile: "",
            manage_location_status_transfer: "",
            committee_reason: "",
            committee_remark: "",
            committee_meeting_no: "",
            committee_meeting_date: "",
            committee_doc_no: "",
            committee_doc_date: "",
            committee_chairman_title: "",
            committee_chairman_firstname: "",
            committee_chairman_lastname: "",
            committee_chairman_position: ""
          }
        );

        if (result.data.status) {
          await this.writeLog({
            manage_id_ref: this.cancelOpinionItem.manage_id_ref,
            action: "ยกเลิกความเห็น",
            committee: this.cancelOpinionItem.Mcommittee,
            remark: this.cancelReason,
            user: userSession.user_name
          });
          Swal.fire({
            icon: "success",
            title: "ยกเลิกความเห็นเรียบร้อยแล้ว",
            showConfirmButton: false,
            timer: 1500
          });
          this.transference_manage_locationQueryAll();
        } else {
          Swal.fire({
            icon: "warning",
            title: "เกิดข้อผิดพลาดในการยกเลิก",
            showConfirmButton: false,
            timer: 1500
          });
        }
      } catch (e) {
        Swal.fire({ icon: "error", title: "เกิดข้อผิดพลาด", text: e.message });
      } finally {
        this.cancelling = false;
        this.cancelOpinionDialog = false;
        this.cancelOpinionItem = null;
      }
    },

    // ─────────────────────────────────────────────
    // PDF Dialog
    // ─────────────────────────────────────────────
    openPdfmanage_id_refDialog(item) {
      if (!item?.manage_id_ref) {
        this.showSnackbar(
          "warning",
          "mdi-alert",
          "ไม่พบรหัสอ้างอิงสำหรับรายการนี้"
        );
        return;
      }
      this.pdfMode = "form";
      this.pdfItem = item;
      this.pdfUrl =
        "/uploads/transference_manage/" + item.manage_file_attachment;
      this.pdfLoading = true;
      this.pdfLoadError = false;
      this.pdfDialog = true;
    },

    openPdfDialog(item) {
      if (!item.MdocumentsLinkfile) {
        this.showSnackbar(
          "warning",
          "mdi-alert",
          "ไม่พบไฟล์แนบสำหรับรายการนี้"
        );
        return;
      }
      this.pdfMode = "assessment";
      this.pdfItem = item;
      this.pdfUrl = "/HRvecfiles/" + item.MdocumentsLinkfile;
      this.pdfLoading = true;
      this.pdfLoadError = false;
      this.pdfDialog = true;
    },

    openExistingFile() {
      if (!this.existingFile) return;
      window.open("/HRvecfiles/" + this.existingFile, "_blank");
    },

    onPdfLoad() {
      this.pdfLoading = false;
    },
    onPdfError() {
      this.pdfLoading = false;
      this.pdfLoadError = true;
    },

    closePdfDialog() {
      this.pdfDialog = false;
      setTimeout(() => {
        this.pdfItem = null;
        this.pdfUrl = "";
        this.pdfLoading = false;
        this.pdfLoadError = false;
        this.pdfMode = "form";
      }, 300);
    },

    closePdfAndEdit(item) {
      this.closePdfDialog();
      this.$nextTick(() => {
        this.select_idPosition(item.manage_id_ref, item.manage_location_id_tfl);
      });
    },

    // ─────────────────────────────────────────────
    // Log
    // ─────────────────────────────────────────────
    async writeLog({ manage_id_ref, action, committee, remark, user }) {
      try {
        await this.$http.post("transference_manage_location_log.php", {
          ApiKey: this.ApiKey,
          log_manage_id_ref: manage_id_ref,
          log_action: action,
          log_committee: committee,
          log_remark: remark,
          log_user: user,
          log_ip: ""
        });
      } catch (e) {
        console.warn("Log write failed:", e);
      }
    },

    async viewLog(manage_id_ref) {
      try {
        let result = await this.$http.post(
          "transference_manage_location_log.php",
          {
            ApiKey: this.ApiKey,
            query_manage_id_ref: manage_id_ref
          }
        );
        this.actionLogs = result.data || [];
        this.logDialog = true;
      } catch (e) {
        this.showSnackbar("error", "mdi-alert", "ไม่สามารถโหลด Log ได้");
      }
    },

    getLogColor(action) {
      if (action === "บันทึกความเห็น") return "green";
      if (action === "แก้ไขความเห็น") return "blue";
      if (action === "ยกเลิกความเห็น") return "red";
      return "grey";
    },

    // ─────────────────────────────────────────────
    // Helpers
    // ─────────────────────────────────────────────
    isDataComplete(item) {
      return (
        !!item.Mcommittee &&
        !!item.MdocumentsLinkfile &&
        !!item.committee_meeting_no &&
        !!item.committee_meeting_date &&
        !!item.committee_doc_no &&
        !!item.committee_chairman_firstname
      );
    },

    rowClass(item) {
      if (!item.Mcommittee) return "";
      if (!this.isDataComplete(item)) return "red lighten-5";
      return "";
    },

    // ─────────────────────────────────────────────
    // พิมพ์ PDF แบบเสนอความเห็นคณะกรรมการสถานศึกษา
    // ─────────────────────────────────────────────

    /**
     * พิมพ์ 1 รายการ (เรียกจากปุ่มในแถว)
     * backend บันทึกไฟล์ลง exports/ แล้ว return JSON { success, pdfUrl, filename }
     */
    async printCommitteePdf(item) {
      if (!item.Mcommittee) {
        this.showSnackbar(
          "warning",
          "mdi-alert",
          "กรุณาบันทึกความเห็นก่อนพิมพ์"
        );
        return;
      }

      this.printPreviewItem = item;
      this.printPreviewMode = "single";
      this.printPreviewError = false;
      this.printPreviewLoading = true;
      this.printPreviewDialog = true;
      this.printPreviewUrl = "";

      try {
        const result = await this.$http.post(
          "generate_manage_committee_pdf.php",
          {
            ApiKey: this.ApiKey,
            manage_location_id_tfl: item.manage_location_id_tfl
          }
        );
          console.log("PDF generation result:", result.data);
        const data = result.data;
        if (!data.success)
          throw new Error(data.message || data.error || "เกิดข้อผิดพลาด");

        this.printPreviewFilename = data.filename;
        this.printPreviewUrl = data.pdfUrl;
      } catch (e) {
        this.printPreviewLoading = false;
        this.printPreviewError = true;
        this.showSnackbar(
          "error",
          "mdi-alert-circle",
          "สร้าง PDF ไม่สำเร็จ: " + e.message
        );
      }
    },

    /**
     * พิมพ์ทุกรายการของวิทยาลัย
     * backend บันทึกไฟล์ลง exports/ แล้ว return JSON { success, pdfUrl, filename }
     */
    async printAllCommitteePdf() {
      const userSession = JSON.parse(localStorage.getItem("user")) || {};
      const collegeCode = userSession.user_name;

      if (!collegeCode) {
        this.showSnackbar("error", "mdi-alert", "ไม่พบข้อมูล session");
        return;
      }

      this.printPreviewItem = null;
      this.printPreviewMode = "all";
      this.printPreviewError = false;
      this.printPreviewLoading = true;
      this.printPreviewDialog = true;
      this.printPreviewUrl = "";
      this.printingAll = true;

      try {
        const result = await this.$http.post(
          "generate_manage_committee_pdf.php",
          {
            ApiKey: this.ApiKey,
            college_code: collegeCode,
            manage_time_s: this.periods.period_college_times,
            manage_year_s: this.periods.period_college_year
          }
        );

        const data = result.data;
        if (!data.success)
          throw new Error(data.message || data.error || "เกิดข้อผิดพลาด");

        this.printPreviewFilename = data.filename;
        this.printPreviewUrl = data.pdfUrl;
      } catch (e) {
        this.printPreviewLoading = false;
        this.printPreviewError = true;
        this.showSnackbar(
          "error",
          "mdi-alert-circle",
          "สร้าง PDF ไม่สำเร็จ: " + e.message
        );
      } finally {
        this.printingAll = false;
      }
    },

    /** ปิด print preview (URL เป็น path ปกติ ไม่ต้อง revoke blob) */
    closePrintPreview() {
      this.printPreviewDialog = false;
      setTimeout(() => {
        // URL เป็น path ปกติ (exports/filename.pdf) ไม่ต้อง revoke
        this.printPreviewUrl = "";
        this.printPreviewFilename = "committee_opinion.pdf";
        this.printPreviewItem = null;
        this.printPreviewLoading = false;
        this.printPreviewError = false;
        this.printPreviewMode = "single";
      }, 300);
    },

    /**
     * ปิด print preview แล้วเปิด dialog แนบไฟล์ทันที
     * ใช้เมื่อผู้ใช้พิมพ์ ลงนาม สแกนแล้ว ต้องการแนบกลับ
     */
    closePrintAndUpload(item) {
      this.closePrintPreview();
      this.$nextTick(() => {
        // เปิด dialog กรอกความเห็น (edit mode) เพื่อ upload ไฟล์ที่สแกนแล้ว
        this.select_idPosition(item.manage_id_ref, item.manage_location_id_tfl);
      });
    },

    showSnackbar(color, icon, text) {
      this.snackbar.color = color;
      this.snackbar.icon = icon;
      this.snackbar.text = text;
      this.snackbar.show = true;
    }
  }
};
</script>
